import { render } from "./DutyTeacher.vue?vue&type=template&id=4dadaaa4"
import script from "./DutyTeacher.vue?vue&type=script&lang=js"
export * from "./DutyTeacher.vue?vue&type=script&lang=js"

import "./DutyTeacher.vue?vue&type=style&index=0&id=4dadaaa4&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__